export const DOWNLOAD_CONFIG = {
  OUTPUT_FORMAT: 'zip',
  FILE_EXTENSION: '.zip',
} as const;

export const DOWNLOAD_MODE = {
  STUDY: 'study',
  SUBJECTS: 'subjects',
} as const;

export const DOWNLOAD_JOB_CONFIG = {
  POLL_INTERVAL_MS: 5000,
  // Bound each status request and a continuous run of failed status checks.
  STATUS_TIMEOUT_MS: 30000,
  // Stop packaging only after this long without a percentage increase.
  PACKAGING_TIMEOUT_MS: 15 * 60 * 1000,
} as const;

export enum DownloadStatus {
  IDLE = 'idle',
  PREPARING = 'preparing',
  PROCESSING = 'processing',
  ACQUIRING = 'acquiring',
  RECONNECTING = 'reconnecting',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export enum JobStatus {
  QUEUED = 'queued',
  PROCESSING = 'processing',
  COMPLETE = 'complete',
  FAILED = 'failed',
}
